<template>
  <section class="section section--post" :class="`section--post-${postID}`">
    <aside class="left-panel">
      <TheLogo />
      <div
        class="animation-box__wrapper"
        :class="isContactPanelActive ? 'fadeout-desktop' : 'fadein-desktop'"
      >
        <div
          class="animation-box animation-box--6"
          v-lazy:background-image="require('@/assets/img/sprites/compressed/post-'+postID+'.png')"
        ></div>
      </div>
      <SocialMedia :isContactPanelActive="isContactPanelActive" />
    </aside>
    <MobileNavBar v-if="isMobile" :isBackgroundPrimary="true" />

    <div v-if="isMobile" class="post-header--mobile">
      <div class="subtitle-container">
        <h2>{{posts[postID].title}}</h2>
        <img src="../../assets/img/meta-decor.svg" alt="decor" />
      </div>
      <div class="animation-box__wrapper">
        <div
          class="animation-box animation-box--6"
          :style="`background-image: url(${require('@/assets/img/sprites/compressed/post-'+postID+'.png')})`"
        ></div>
      </div>
      <div class="mobile-title-container">
        <BackToPostListArrow v-if="isMobile" iconColor="white" />
        <h1>{{posts[postID].subtitle}}</h1>
      </div>

      <img
        src="../../assets/img/arrow-down-white.svg"
        class="scroll-next"
        alt
        @click="scrollToNext"
      />
    </div>

    <main class="main">
      <BackToPostListArrow v-if="!isMobile" />
      <ContactBtn v-if="!isMobile" />
      <div class="meta__row">
        <div class="meta">
          <span class="meta__author">{{posts[postID].author}}</span>
          <span class="meta__date">{{posts[postID].postDate}}</span>
        </div>
        <div class="meta__decor">
          <img src="../../assets/img/meta-decor.svg" alt="decor" />
        </div>
      </div>
      <h2 v-if="!isMobile">{{posts[postID].title}}</h2>
      <h1 v-if="!isMobile">{{posts[postID].subtitle}}</h1>
      <div class="post">
        <Post1 :postID="postID" v-if="postID === 1" />
        <Post2 :postID="postID" v-else-if="postID === 2" />
        <Post3 :postID="postID" v-else-if="postID === 3" />
        <Post4 :postID="postID" v-else-if="postID === 4" />
        <Post5 :postID="postID" v-else-if="postID === 5" />
        <Post6 :postID="postID" v-else-if="postID === 6" />
        <Post0 :postID="postID" v-else />
      </div>
    </main>
  </section>
</template>

<script>
// import { bus } from "../../main";

import postsData from "../../singlePostsData";
import TheLogo from "../TheLogo";
import BackToPostListArrow from "../BackToPostListArrow";
import ContactBtn from "../ContactBtn";
import SocialMedia from "../SocialMedia";
import MobileNavBar from "../mobile/MobileNavBar";

/* POSTS */
import Post0 from "../posts/Post0";
import Post1 from "../posts/Post1";
import Post2 from "../posts/Post2";
import Post3 from "../posts/Post3";
import Post4 from "../posts/Post4";
import Post5 from "../posts/Post5";
import Post6 from "../posts/Post6";

export default {
  components: {
    TheLogo,
    BackToPostListArrow,
    ContactBtn,
    SocialMedia,
    Post0,
    Post1,
    Post2,
    Post3,
    Post4,
    Post5,
    Post6,
    MobileNavBar
  },
  name: "PostSingle",
  data: function() {
    return {
      posts: postsData
    };
  },
  props: {
    postID: Number,
    isContactPanelActive: Boolean,
    isMobile: Boolean
  },
  methods: {
    scrollToNext() {
      const main = document.querySelector(".section--post main");
      const mainOffset = main.offsetTop;

      window.scrollTo({
        top: mainOffset - 92,
        left: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style lang="scss">
.post {
  ul {
    list-style-type: none;
    padding-left: 40px;

    @media (max-width: $tablet) {
      padding-left: 20px;

      li {
        padding-left: 20px;
      }
    }

    &:not(:first-child) {
      padding-top: 25px;
    }

    li {
      font-family: $font-family-heading;
      line-height: 2;
      position: relative;
      padding-left: 60px;

      &:not(:last-child) {
        margin-bottom: 2em;
      }

      &::before {
        content: "";
        display: block;
        position: absolute;
        top: 0.7em;
        left: 0px;
        height: 12px;
        width: 24px;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url(../../assets/img/arrow-right.svg);
      }
    }
  }

  .heading--sans-serif {
    font-family: $font-family-text;
    color: $primary-color;
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 25px;
  }

  .certificate {
    font-weight: 600;
    // text-align: center;
    margin-bottom: 30px;
    color: $primary-color;

    &--indend {
      text-align: left;
      font-weight: 300;
      // padding-left: 30px;
      display: block;
      margin: 30px 0;

      span {
        font-style: italic;
      }
    }
  }

  a {
    &:hover {
      text-decoration: underline;
    }
  }

  .source-link {
    font-style: italic;
    color: $primary-color;
    font-family: $font-family-heading;
    word-break: break-all;
    margin-top: 10px;
    display: inline-block;

    &--right {
      display: block;
      text-align: right;
    }

    &:hover {
      text-decoration: underline;
      color: $primary-color;
    }
  }
}

.section--post {
  animation: fadeIn 2s ease both;

  & + .contact-panel {
    background-color: $primary-color;
  }

  .main.main {
    padding-top: 100px + $screen-gutter-top;
    margin-left: auto;
  }

  h1 {
    margin-top: 45px;
    margin-bottom: 35px;
    font-weight: 600;
    font-size: 55px;
    line-height: 1.27;
    color: $primary-color;
    max-width: 655px;

    span.block {
      display: inline;
    }

    span.dash {
      display: none;
    }
  }

  h2 {
    font-weight: 500;
    margin-top: 35px;
    font-family: $font-family-heading;
    font-size: 25px;
    line-height: 0.96;
  }

  .text-background {
    background-color: $primary-color;
  }

  .backToPosts {
    position: fixed;
    top: $screen-gutter-top;
    left: calc(100% - #{$main-width} + #{$main-gutter-left});
    z-index: 2;
  }

  .meta {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 250px;
    margin-right: 20px;

    &__row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 65%;
    }

    &__author {
      font-size: 15px;
    }
  }

  .animation-box {
    &__wrapper {
      overflow: hidden;
      margin: 150px -#{$aside-gutter-right} 0 -#{$screen-gutter-left};
      height: 0;
      padding-bottom: calc(
        100% + #{$aside-gutter-right} + #{$screen-gutter-left}
      );
    }
  }

  .left-panel {
    position: fixed;
    width: 33%;
    height: 100%;

    .socials {
      position: absolute;
      bottom: $screen-gutter-bottom - 5px;
      left: $screen-gutter-left - 1px;
      width: calc(100% - #{$screen-gutter-left} - #{$aside-gutter-right});
    }
  }

  .post-header {
    &--mobile {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      background-color: $primary-color;
      min-height: 100vh;
      width: 100%;
      position: relative;
      padding: 100px 6% 40px;

      .animation-box__wrapper {
        margin: 0;
        padding-bottom: 100%;
      }

      .scroll-next {
        display: none;
        position: absolute;
        bottom: 40px;
        right: 6%;
        z-index: 3;
      }

      h1 {
        display: block;
        max-width: 300px;
        color: #fff;
        margin: -20% 0 0;
        font-size: 30px;
      }

      .subtitle-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: -20%;

        h2 {
          margin-top: 0;
          font-size: 15px;
          font-family: $font-family-text;
          font-weight: 600;
        }

        img {
          width: 15px;
        }
      }
    }
  }

  @media (max-width: $tablet) {
    flex-direction: column;
    .post-header--mobile {
      .mobile-title-container {
        h1 {
          margin-top: 0;
        }

        .backToPosts {
          position: static;
          margin-top: 0;
          margin-bottom: 15px;
        }
      }
    }

    .main.main {
      padding-top: 26px;
      flex-grow: 1;

      p {
        font-size: 18px;
        line-height: 1.78;
      }

      .meta {
        &__row {
          width: 100%;
        }
      }

      .row--flex {
        flex-direction: column;
      }

      .scroll-to-top {
        bottom: 36px;
        right: 20px;
        left: unset;
      }

      .post-content {
        padding-bottom: 0;
      }

      .col-70 {
        width: 100%;
        flex: 0 0 100%;
        padding: 0;
      }

      .col-30 {
        width: 100%;
        flex: 0 0 100%;
      }

      .indend-left {
        padding: 0;
      }

      .related-news {
        margin-top: 130px;
        position: relative;
        padding-right: 6%;

        &::before {
          content: "";
          display: block;
          width: 94%;
          height: 1px;
          background-color: $black-color;
          position: absolute;
          top: -100px;
          left: 0;
        }

        .header {
          right: 6%;
        }

        .post {
          background-color: $primary-color;
          padding: 26px 37px 29px 32px;

          &-title {
            color: #fff;
            font-size: 25px;
            line-height: 1.4;
          }
        }
      }
    }

    .mobile-navbar {
      position: fixed;
      top: 0;
      left: 0;
      padding: 26px 6%;
      z-index: 5;

      background-color: $primary-color;
      color: #fff;
    }
  }
}
</style>